import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faEye } from '@fortawesome/free-solid-svg-icons';
import './ProductTable.css';

const ProductTable = ({ products, isEmbedded }) => {
    const navigate = useNavigate();

    const handleEdit = (uuid) => {
        navigate(`/edit-product/${uuid}`);
    };

    const handleView = (uuid) => {
        navigate(`/product/${uuid}`);
    };

    const formatPrice = (amount) => {
        return parseFloat(amount).toLocaleString('es-CO');
    };

    return (
        <div className="product-table-container">
            <table className="product-table">
                <thead>
                    <tr>
                        <th>Imagen</th>
                        <th>Nombre</th>
                        <th>Categoría</th>
                        <th>Precio</th>
                        <th>Estado</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {products.map((product) => (
                        <tr key={product.uuid}>
                            <td>
                                <img 
                                    src={product.image} 
                                    alt={product.name}
                                    className="product-table-image"
                                />
                            </td>
                            <td className="product-table-name">{product.name}</td>
                            <td>{product.subCategory?.name || 'Sin categoría'}</td>
                            <td className="product-table-price">
                                ${formatPrice(product.prices[0]?.amount || 0)}
                            </td>
                            <td>
                                <span className={`product-table-status ${product.status || 'active'}`}>
                                    {product.status === 'active' ? 'Activo' : 'Inactivo'}
                                </span>
                            </td>
                            <td className="product-table-actions">
                                <button 
                                    className="product-table-btn edit"
                                    onClick={() => handleEdit(product.uuid)}
                                    title="Editar"
                                >
                                    <FontAwesomeIcon icon={faPen} />
                                </button>
                                {!isEmbedded && (
                                    <button 
                                        className="product-table-btn view"
                                        onClick={() => handleView(product.uuid)}
                                        title="Ver"
                                    >
                                        <FontAwesomeIcon icon={faEye} />
                                    </button>
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default ProductTable;
